export enum TLocksButtonVisibility {
  ShowAll = 'showAll',
  HideAll = 'hideAll',
  HideLast = 'hideLast',
}

export type TTheme = {
  device?: {
    mobile: boolean;
    //mobile + horizontal view
    landscape: boolean;
    ios: boolean;
    tablet: boolean;
  };
};

export type Props = {
  isEnablePreviousStep: boolean;
  isEnableNextStep: boolean;
  description?: string;
  stepIconUrl?: string | null;
  title?: string;
  color: any;
  pathSettings: any;
  pathfinderDataState: any;
  translation?: Record<string, string>;
  gameId: number;
  finishedPaths?: number[];
  currentPathStepId: number;
  isRtl: boolean;
  delayedDisable: boolean;
  forceShowPathSwitchMobileModal: boolean;
  pathLockId: number;
  recoilStateObj: { bottomBarOpenState: any; tourConfigsState: any };
  asyncStore: { pathIds?: number[] };
  theme: TTheme;
  APP_AWS?: string;
  pathSnapshot: any;
  pathLocks?: any[]; //GameLock
  handleChangePath?: (e: any) => void;
  setForceShowPathSwitchMobileModal: (e: boolean | any) => void;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  setPathfinderDataState: (data: any) => void;
  useRecoilValue: (d: any) => any;
  buttonOnlyMode?: boolean;
  nextButtonVisibility?: TLocksButtonVisibility;
  icon?: string;
  distance?: string;
};
